module.exports = __webpack_public_path__ + "img/xiaoimg.c6d72cce.png";